import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import {
  IconMailCheck,
  IconLoader2,
  IconAlertCircle,
  IconCircleX
} from '@tabler/icons-react';
import LogoIcon from '../components/LogoIcon';
import { useAuth } from '../contexts/AuthContext';
import { authAPI } from '../services/api';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [error, setError] = useState(null);
  const { refreshUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus('error');
        setError('Неверная ссылка подтверждения');
        return;
      }
      try {
        const data = await authAPI.verifyEmail(token);
        if (data && data.access_token) {
          localStorage.setItem('access_token', data.access_token);
        }
        if (data && data.refresh_token) {
          localStorage.setItem('refresh_token', data.refresh_token);
        }
        await refreshUser();
        setStatus('success');
        setTimeout(() => navigate('/dashboard'), 1500);
      } catch (err) {
        setStatus('error');
        setError(err.message || 'Не удалось подтвердить email');
      }
    };
    verify();
  }, [token, refreshUser, navigate]);

  return (
    <div className="min-h-screen bg-white dark:bg-dark-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2.5">
            <LogoIcon />
            <span className="text-xl font-bold text-gray-900 dark:text-white">
              XN Connect
            </span>
          </Link>
        </div>

        <div className="bg-white dark:bg-dark-900 border border-gray-200 dark:border-dark-800 rounded-2xl p-5 sm:p-8 text-center">
          {status === 'loading' && (
            <>
              <div className="w-16 h-16 bg-primary-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <IconLoader2 className="w-8 h-8 text-primary-500 animate-spin" />
              </div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                Подтверждаем email...
              </h2>
              <p className="text-gray-600 dark:text-dark-400 text-sm">
                Пожалуйста, подождите
              </p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <IconMailCheck className="w-8 h-8 text-green-500" />
              </div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                Email подтверждён!
              </h2>
              <p className="text-gray-600 dark:text-dark-400 text-sm mb-4">
                Перенаправляем вас в панель управления...
              </p>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <IconCircleX className="w-8 h-8 text-red-500" />
              </div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                Ошибка подтверждения
              </h2>
              <div className="flex items-start gap-2 p-3 bg-red-500/10 border border-red-500/30 rounded-lg mb-4 text-left">
                <IconAlertCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
                <p className="text-red-400 text-sm">{error}</p>
              </div>
              <Link
                to="/login"
                className="inline-block w-full py-3 bg-primary-500 hover:bg-primary-600 rounded-lg font-semibold text-white transition-colors"
              >
                Войти
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
